import { Box } from 'components/ui';
import sectionsPreview from 'img/preview-sections.png';
import matrixPreview from 'img/preview-matrix.png';
import RoundedBox from 'components/Traits/RoundedBox';


interface MusicStructureProps {}

const MusicStructure: React.FC<MusicStructureProps> = () => {
  return (
    <>
      <Box fontSize={4} mt={4} fontWeight="bold">
        How Futura music is structured
      </Box>
      <RoundedBox>
        <ul>
          <li>
            Each Futura NFT is structured as a matrix of both sections and layers.
            <ul>
              <li>
                <b>Sections</b> are the sequential components that build up a full song and are
                analogous to standard song sections from many contemporary music styles e.g. intro,
                buildup, drop, etc.
              </li>
              <li>
                The six sections all Futura songs break down by are: Intro, Verse, Buildup 1,
                Bridge, Buildup 2, Drop.
                <Box my={3} width="100%" maxWidth="600px" margin="24px auto">
                  <img src={sectionsPreview} width="100%" alt="sections preview" />
                </Box>
              </li>
              <li>
                <b>Layers</b> are specific sounds that play in each section, aka specific musical
                instruments. These are semi-analogous to stems from traditional music production,
                although in Futura’s case our stems (Layers) frequently contain multiple different
                instruments. This helps keep the number of layers manageable - in our case there are
                five layers.
                <ol>
                  <li>Lead - this is usually the lead synth or other instrument.</li>
                  <li>Backing - this is often the supporting bassline</li>
                  <li>
                    Drums - this is the drum track, combining most of the drums into one layer
                  </li>
                  <li>
                    Ambience - this track often features atmospheric effects like risers and falling
                    sounds
                  </li>
                  <li>
                    FX - this layer contains FX sounds that add different flavours to sections
                  </li>
                </ol>
              </li>
              <li>
                This section/layer structure provides up to 30 cells for each song, where an
                individual piece of music can appear.
              </li>
              <li>
                The specific piece of music that appears in each section/layer matrix cell is known
                as a Futura Clip.
              </li>
            </ul>
          </li>

          <li>
            Futura can be composed of up to 30 different music clips.
            <Box width="100%" maxWidth="800px" margin="24px auto">
              <img src={matrixPreview} width="100%" alt="matrix preview" />
            </Box>
          </li>
        </ul>
      </RoundedBox>
    </>
  );
};

export default MusicStructure;
